import { Box, Grid, Tooltip } from '@mui/material'
import { format, isValid, parse } from 'date-fns'
import CardSectionHeader from './CardSectionHeader'
import React from 'react'
import styled from 'styled-components'

const ApplicationsContainer = styled(Grid)`
	padding: 1.25rem;
`

const ApplicationInfoLabel = styled(Grid)`
	display: inline-block;
	font-weight: normal;
	font-size: 0.875rem;
	line-height: 1.375rem;
`

const ApplicationInfoValue = styled(Grid)`
	display: inline-block;
	font-weight: 500;
	font-size: 1rem;
	line-height: 1.25rem;
`

const ApplicationField = ({ label, children }) => {
  return (
    <Grid container direction="column" item xs={12}>
      <ApplicationInfoLabel item xs>
        <div>{label}</div>
      </ApplicationInfoLabel>
      <ApplicationInfoValue item>
        <div>{children}</div>
      </ApplicationInfoValue>
    </Grid>
  )
}

const ApplicationsSection = ({ applicationsInfo }) => {
  return (
    <ApplicationsContainer item xs={6}>
      <CardSectionHeader>
				Applications ({applicationsInfo.length})
      </CardSectionHeader>
      <Grid container direction="row" item wrap="nowrap">
        <ApplicationField label="Client" xs={4}>
          {applicationsInfo.map((application, index) => {
            return (
              <Box key={index}>
                <Tooltip title={application.client}>
                  <span>{application.client.substring(0, 10) + '...'}</span>
                </Tooltip>
              </Box>
            )
          })}
        </ApplicationField>
        <ApplicationField label="Brand" xs={4}>
          {applicationsInfo.map((application, index) => {
            return (
              <div key={index}>
                <Tooltip title={application.brand}>
                  <span>{application.brand.substring(0, 10) + '...'}</span>
                </Tooltip>
              </div>
            )
          })}
        </ApplicationField>
        <ApplicationField label="Applied Date" xs={4}>
          {applicationsInfo.map((application, index) => {
            const appliedDate = parse(
              application.appliedDate,
              'yyyy-MM-dd HH:mm:ss.SSSS',
              new Date(),
            )
            if (!isValid(appliedDate))
              return <div key={index}>Invalid Date</div>
            const formattedDate = format(appliedDate, 'M-d-yyyy')
            return <div key={index}>{formattedDate}</div>
          })}
        </ApplicationField>
      </Grid>
    </ApplicationsContainer>
  )
}

export default ApplicationsSection
